import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Commercial from "./Commercial";
import AppHeader from "components/Header/AppHeader";
import MDBox from "components/MDBox";

function CommercilaInsightsPage({ subcategoryToken }) {

  return (
    <DashboardLayout>
      <MDBox
        sx={{
          display: {
            xs: "block",
            sm: "block",
            md: "none",
          },
        }}
      >
        <AppHeader />
      </MDBox>
      <Commercial subcategoryToken={subcategoryToken} />
    </DashboardLayout>
  );
}

export default CommercilaInsightsPage;
